module.exports = __webpack_public_path__ + "static/media/buffalo-chicken-dumpling.a81d2e91.png";